import React from "react";
import List from "./feature/list";

const BulkEditActivity = () => {
  return <List />;
};
export default BulkEditActivity;
